import { css } from 'styled-components';
import { mqSmallMin, mqLargeMin } from 'styled/tools/media-queries';

export const SitePopup = css`
  .site-popup {
    align-items: flex-start;
    justify-content: center;
    display: none;
    position: fixed;
    overflow: auto;
    z-index: 9999;
    height: 100vh;
    width: 100%;
    left: 0;
    bottom: 0;
    bottom: env(safe-area-inset-bottom);
    &.active {
      display: flex;
    }
  }

  .site-popup-bg {
    background: rgba(255, 255, 255, 0.75);
    position: fixed;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
  }

  .site-popup-card {
    padding: var(--spacing-48) 0;
    background-color: var(--fill-neutral-light);
    margin: var(--spacing-48) auto;
    width: calc(100% - 60px);
    position: relative;
    height: auto;

    @media ${mqSmallMin} {
      border-radius: 0.5; //possibly broken
      margin: 100px auto;
      max-width: 600px;
    }

    @media ${mqLargeMin} {
      margin: 200px auto;
      max-width: 1200px;
      width: 80%;
    }

    animation: slide-up 0.25s ease;
    display: flex;
    flex-direction: column;
  }

  .site-popup-exit {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: var(--font-size-400);
    position: absolute;
    cursor: pointer;
    z-index: 9999;
    color: #000;
    right: 0;
    top: 0;
    width: 30px;
    height: 30px;
    line-height: 30px;
    background: transparent;
    border: 0;

    &:hover,
    &:focus {
      color: var(--text-primary);
    }
  }

  .site-popup-drawer {
    transform: translateX(100%);
    border-radius: 0;
    display: flex;
    flex-direction: column;
    color: var(--text-primary);

    .site-popup-bg {
      background-color: var(--fill-brand);
    }

    .site-popup-card {
      border-radius: 0;
      overflow-y: auto;
      padding: 0 var(--spacing-32);
      margin: 0 0 0 auto;
      background-color: var(--fill-secondary);
      height: 100%;
      width: 100%;

      @media ${mqLargeMin} {
        padding: 0 var(--spacing-48);
      }
    }

    .site-popup-exit {
      transform: translateY(-2px);
      right: var(--spacing-32);
      top: var(--spacing-48);

      @media ${mqLargeMin} {
        transform: translate(-5px, -3px);
        right: var(--spacing-48);
        top: 45px;
      }
    }

    .site-popup-card > .container {
      width: 100%;

      > .head {
        display: block;
        padding: 45px 0 80px;

        * {
          display: inline-block;
          font-size: var(--font-size-350);
        }

        .title {
          font-weight: 500;
          margin-right: var(--spacing-24);
        }

        h3,
        p {
          font-family: var(--flag-font-family);
          font-weight: 500;
          margin: 0 var(--spacing-24) 0 0;
        }

        span {
          font-weight: 400;
        }
      }

      > .body {
        padding-bottom: 100px;
      }
    }
  }

  .site-popup-modal.active.animation-out .site-popup-bg,
  .site-popup-drawer.active.animation-out .site-popup-bg,
  .site-popup-modal .site-popup-bg,
  .site-popup-drawer .site-popup-bg {
    background-color: rgba(28, 58, 19, 0.4);
    transition: opacity 0.2s ease;
    animation-delay: 0.5s;
    opacity: 0;
    backdrop-filter: blur(5px);
  }

  .site-popup-modal.active.animation-out .site-popup-bg,
  .site-popup-modal .site-popup-bg {
    transition: opacity 1.5s ease;
    animation-delay: 0s;
  }

  .site-popup-drawer.active .site-popup-bg,
  .site-popup-modal.active .site-popup-bg {
    opacity: 1;
  }

  .site-popup-drawer.active.animation-out .site-popup-card,
  .site-popup-modal.active.animation-out .site-popup-card,
  .site-popup-drawer .site-popup-card {
    transition: transform 0.5s ease;
    transform: translateX(100%);
  }

  .site-popup-drawer.active .site-popup-card {
    transform: translateX(0);
  }

  .site-popup-drawer.active {
    transform: translateX(0);
    height: 100%;
    max-width: 100%;
    overflow-x: hidden;
    position: fixed;
  }

  .site-popup-drawer .site-popup-exit {
    display: flex;
    align-items: center;
    justify-content: center;
    transform: scale(1.25);
    text-align: center;
    font-size: var(--font-size-400);
    position: absolute;
    cursor: pointer;
    z-index: 9999;
    color: #000;
    width: 30px;
    height: 30px;
    line-height: 30px;
    right: 30px;
    top: 42px;

    @media ${mqLargeMin} {
      right: 45px;
    }

    * {
      stroke: var(--outline-primary);
      fill: var(--fill-brand);
    }
  }

  .site-fixed-nav-bg {
    transition: opacity 0.4s ease-in-out;
    position: fixed;
    height: 100%;
    width: 100%;
    display: block;
    z-index: 1;
    opacity: 0;
    left: 0;
    top: 0;
    background: rgba(28, 58, 19, 0.7);
    backdrop-filter: blur(5px);

    @media ${mqLargeMin} {
      display: none;
    }

    &.active {
      opacity: 1;
    }
  }
`;
